import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-cols"];
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'FormRow',
    props: {
        columns: {}
    },
    setup(__props) {
        const props = __props;
        const cols = computed(() => Math.min(4, Math.max(1, props.columns || 2)));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "formRow",
                "data-cols": cols.value
            }, [
                _renderSlot(_ctx.$slots, "default")
            ], 8, _hoisted_1));
        };
    }
});
